export const reimburseRouter = [
  {
    path: "/projectPayment/reimburse/list",
    name: "reimburse-list",
    meta: { title: "报销单" },
    component: () =>
      import(
        /* webpackChunkName: "reimburse" */ "@/views/project-payment/reimburse/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/reimburse/create",
    name: "external-payment-create",
    meta: { title: "新增报销单", comName:"ProjectPaymentReimburseFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "reimburse" */ "@/views/project-payment/reimburse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/reimburse/edit/:id",
    name: "external-payment-edit",
    meta: { title: "编辑报销单", comName:"ProjectPaymentReimburseFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "reimburse" */ "@/views/project-payment/reimburse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/reimburse/detail/:id",
    name: "reimburse-detail",
    meta: { title: "报销单详情" },
    component: () =>
      import(
        /* webpackChunkName: "reimburse" */ "@/views/project-payment/reimburse/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/reimburse/flowPrint/:id",
    name: "projectPayment-reimburse-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "projectPayment-reimburse" */ "@/views/project-payment/reimburse/flow-print/index.vue"
      ),
  },
];
